module.exports = __webpack_public_path__ + "img/pop_kefu.a033af01.jpg";